import React from 'react';
import Select from 'react-select';
import Toaster from 'toastr';
import Constants from '../../../configurations/constants';
import Urls from '../../../configurations/urls';
import Messages from '../../../configurations/messages';
import ArbiterApi from '../../../api/ArbiterApi';
import SubHeader from '../../common/subHeader';
import Divider from '../../common/divider';

class BulkDisputeFileUpload extends React.Component{

    constructor(props, context)
    {
        super(props,context);
        this.state ={
            transactionGroups : [],
            categories : [],
            currentTransactionGroup : null,
            selectedChannel : null,
            category : null, 
            batchFile : null
        };
        this.handleTranGroupChange = this.handleTranGroupChange.bind(this);
        this.handleChannelChange = this.handleChannelChange.bind(this);
        this.handleCategoryChange = this.handleCategoryChange.bind(this);
        this.handleFileAttached = this.handleFileAttached.bind(this);
        this.handleFileUpload = this.handleFileUpload.bind(this);
        
         
    }
    
    componentDidMount() {
        //Get Transaction Groups
        ArbiterApi.getTransactionGroups()
            .then(response => {
                let data = response.data;
                let groups = data || [];
                //Map groups to support the select field e.g add label and value properties
                groups = groups.map(item => {
                    item.label = item.name;
                    item.value = item.name;
                    return item;
                });
                this.setState({ transactionGroups: groups });
            })
            .catch(error => {
                console.log(error);
                Toaster.error(`${error.data ? error.data.description : error.statusText}`, `${Messages.ERROR_TRANSACTION_GROUPS} - ${error.status} - `);
            });
        //Get Dispute Categories
        ArbiterApi.getDisputeCategories()
        .then(response =>{
            let categories = response.data.map(obj =>{
                
                obj.label = obj.category;
                obj.value = obj.category;
                obj.statuses =  obj.statuses.map(status => {
                    return {
                        label : status,
                        value : status,
                    }
                })
                return obj;
            });
            this.setState({categories});
        })
        .catch(error => {
            Toaster.error(`${error.status} - ${Messages.ERROR_DISPUTE_CATEGORIES} - ${error.data ? error.data.description : error.statusText}`);
            console.log(error);
        })

    }

    handleFileAttached(event){
        let target = event.target;
        let files = [];
        for (let i = 0; i < target.files.length; i++) {
            let file = target.files[i];
            files.push(file);
        }

        this.setState({ batchFile: files.length === 0 ? null :  files[0] });
    }
    handleTranGroupChange(event)
    {
        //Map channels
        let channels = !event || !event.channels ? [] :  event.channels.map(c =>{
            let channel = event.groups[c];
            channel.label =  channel.channel;
            channel.value = channel.channel;
            return channel;
        });
        
        //Select first channel if only one chennel in the list
        let selectedChannel =  channels.length === 1 ? channels[0] :  null;

        this.setState({
            currentTransactionGroup: event,
            selectedChannel : selectedChannel,
            channels : channels,
            category : null
        });

    }
    handleChannelChange(evt)
    {
        this.setState({
            selectedChannel : evt,
            category : null
        });
    }
    handleCategoryChange(evt)
    {
        this.setState({
            category : evt
        });
    }

    handleFileUpload(event){
        this.props.onUpload({
            transactionGroup:this.state.currentTransactionGroup.value,
            transactionChannel : this.state.selectedChannel.value,
            disputeCategory : this.state.category.value,
            batchFile : this.state.batchFile

        });
    }
    
    render(){

        const group =  this.state.currentTransactionGroup || {};
        const channel = this.state.selectedChannel || {};
        const category = this.state.category || {};
        return(
            <div>
                <Divider />
                <SubHeader title="Files" />
                <Divider />
                <div className="row bulk-template">
                    
                    <div className="col-md-12">
                        <div className="row">
                            <div className="col-md-3">
                                <Select  placeholder="Tran. Group" onChange={this.handleTranGroupChange} options={this.state.transactionGroups} value={this.state.currentTransactionGroup}/>
                            </div>
                            <div className="col-md-3">
                               <Select 
                                        disabled={!(this.state.currentTransactionGroup)} 
                                        placeholder="Channel" 
                                        onChange={this.handleChannelChange} 
                                        options={this.state.channels} 
                                        value={this.state.selectedChannel}/>
                            </div>
                            
                            <div className="col-md-3">
                               <Select  placeholder="Category" onChange={this.handleCategoryChange} options={this.state.categories}
                                     value={this.state.category}
                                     disabled={!(this.state.currentTransactionGroup && this.state.selectedChannel)}/>
                            </div>
                            <div className="col-md-3">
                                <a 
                                    href={this.disableControl() ? '#' : `${Urls.ARBITER_BASE_PATH}${Urls.ARBITER_API_BASE_PATH}${Urls.ARBITER_API_DISPUTES}${Urls.ARBITER_API_DOWNLOAD_TEMPLATE}?transactionGroup=${group.value || ''}&transactionChannel=${channel.value || ''}&disputeCategory=${category.value || ''}`}  
                                    className="button btn btn-primary long-btn" target={this.disableControl() ? "":"_blank"}
                                    disabled={this.disableControl()}
                                    >Download Template
                                </a>
                                
                            </div>
                        </div>
                        
                    </div>
                </div>
              
                   <div className="row">
                    <div className="col-md-6">
                        <div className="section">
                            <input  accept=".xls,.xlsx" disabled={this.disableControl()} type="file"  ref="batchFile" id="batchFile" name="batchFile" style={{width : '100%'}} onChange={this.handleFileAttached}/>
                        </div>
                     </div>
                     <div className="col-md-3"></div>
                     <div className="col-md-3"> <button disabled={this.disableControl() || !this.state.batchFile} className="btn btn-primary long-btn"  onClick={this.handleFileUpload}>Upload Batch</button>
                        </div>
                     
                </div>
               
                
            
            </div>
        );
    }

    disableControl()
    {
        return !(this.state.currentTransactionGroup && this.state.selectedChannel && this.state.category);
    }
}


export default BulkDisputeFileUpload;


// WEBPACK FOOTER //
// ./src/components/disputeMgmt/bulkDisputes/bulkDisputeFileUpload.js